import { BaseDto } from './base.dto';

export class CurrencyDto extends BaseDto {
  name: string;
  code: string;
  symbol: string;
}
